import prettyBytes from "pretty-bytes";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import NewIcon from "assets/icons/new_tab.svg?react";
import DowloadIcon from "assets/icons/download.svg?react";
import AttachIcon from "assets/icons/folder_dossier_added.svg?react";
import { useState } from "react";
import AttachmentIconComponent from "components/AttachmentIconComponent";
import sanitizeHtml from "sanitize-html";
import { useDownloadFileStore } from "store/downloadFile.store";
import Loading from "components/Loading";
import { Can } from "contexts/AbilityContext";
import { useDrag } from "react-dnd";
import { Tooltip } from "@mui/material";
import { isArchiveAttachment } from "utils/isAllowedAttachment";
import { useTranslation } from "react-i18next";

const PackageAttachment: FC<Props> = ({
  date,
  attachment,
  onPreview,
  onDownload,
  onNewWindow,
  onAddDossier,
  isInDossier = false, // eslint-disable-line @typescript-eslint/no-unused-vars
  className = "",
  disableMenu = false,
  sizeInColumn = false,
  handleDoubleClick = null,
}) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [{ opacity }, dragRef] = useDrag(
    () => ({
      type: "attachment",
      item: { id: attachment.Id },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
      }),
    }),
    []
  );

  const { id, progress } = useDownloadFileStore();

  const checkIsArchive = (fileName: string) => {
    fileName = fileName.toLocaleLowerCase();
    const extension = fileName.split(".").at(-1);
    const isAllowed = isArchiveAttachment(extension ?? "no");

    return isAllowed;
  };

  const isArchive = checkIsArchive(attachment.FileName);

  const handleClickOnFile = (e: React.MouseEvent<HTMLDivElement>) => {
    const target: any = e.target;
    console.log(target);

    if (target.dataset.is) {
      onPreview(attachment);
      return;
    }
  };

  return (
    <div
      ref={dragRef}
      style={{ opacity }}
      data-is={true}
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      onClick={handleClickOnFile}
      onDoubleClick={() => {
        handleDoubleClick?.(attachment);
      }}
      className={`${styles.wrapper} ${className}`}
    >
      <div className={styles.content}>
        <div data-is={true}>
          <AttachmentIconComponent
            data-is={true}
            className={styles.iconPDF}
            file={attachment?.FileName ?? ""}
            onClick={() => handleClickOnFile}
          />
        </div>
        <div className={styles.metaData} data-is={true}>
          <div
            data-is={true}
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(attachment?.FileName),
            }}
          ></div>
          {!sizeInColumn && (
            <div data-is={true} className={styles.size}>
              {attachment?.Size &&
                attachment?.Size > 0 &&
                prettyBytes(attachment?.Size ?? 0)}{" "}
              {date && <>{date}</>}
            </div>
          )}
        </div>
        {showMenu && !disableMenu && (
          <div className={styles.menu}>
            {!isArchive && (
              <Tooltip title={t("common.openInNewTab")}>
                <div>
                  <NewIcon onClick={() => onNewWindow(attachment)} />
                </div>
              </Tooltip>
            )}

            <Tooltip title={t("common.download")}>
              <div>
                <DowloadIcon onClick={() => onDownload(attachment)} />
              </div>
            </Tooltip>

            <Can I="accessModule" an="drive">
              {onAddDossier && (
                <Tooltip title={t("chat.attachToDossier")}>
                  <div>
                    <AttachIcon onClick={() => onAddDossier(attachment)} />
                  </div>
                </Tooltip>
              )}
            </Can>
          </div>
        )}
        {sizeInColumn && (
          <div data-is={true} className={styles.size}>
            {attachment?.Size &&
              attachment?.Size > 0 &&
              prettyBytes(attachment?.Size ?? 0)}{" "}
            {date && <>{date}</>}
          </div>
        )}
        {/* {attachment.ShowInDossier > 0 &&
          !showMenu &&
          !disableMenu &&
          onAddDossier && (
            <Can I="accessModule" an="drive">
              <AttachIcon onClick={() => onAddDossier(attachment)} />
            </Can>
          )} */}
      </div>
      <div
        style={{
          width: id === attachment.Id ? `${progress}%` : "0%",
        }}
        className={styles.bar}
      ></div>
      {id === attachment.Id && (
        <div className={styles.loading}>
          <Loading withoutText />
        </div>
      )}
    </div>
  );
};

export default PackageAttachment;
